import React, { useEffect, useState } from "react";
import { translate } from "../../utils/translations/translate";
import { Dropdown } from "../UI/Dropdown";
import {
  DATE_TIME_FORMAT,
  RESOURCE_TYPE_OPTIONS,
  STATUS_OPTIONS,
  TOAST_TIMER,
} from "../../utils/constants";
import Input from "../UI/Input";
import { StyledCreateEditResourceForm } from "./styles";
import { useNavigate } from "react-router-dom";
import Button from "../UI/Button";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
import { useFormik } from "formik";
import { Loader } from "../Loader/Loader";
import { ResourceValidationSchema } from "./utils/schema";
import { useAccount } from "./utils/hooks/useAccount";
import { InfoModal } from "../UI/InfoModal";
import { Alert } from "../UI/Alert";
import moment from "moment";
const supportedModes = ["add", "edit"];
const CreateEditResourceForm = ({ mode, resourceId }) => {
  const formMode = supportedModes.includes(mode) ? mode : "add";
  const navigate = useNavigate();
  const isEditMode = formMode === "edit";
  const [isAccountCreated, setIsAccountCreated] = useState(false);
  const [isDetailsUpdated, setIsDetailsUpdated] = useState(false);
  const {
    errorMessage,
    createOrUpdateResourceAccount,
    isLoading,
    fetchUserAccountDetails,
    hideErrorToast,
  } = useAccount();
  const formik = useFormik({
    initialValues: {
      resourceType: "Employee",
      resourceName: "",
      resourceEmail: "",
      resourceId: "",
      resourceCreatedOn: moment(new Date()).format(DATE_TIME_FORMAT.DISPLAY),
      resourceLastLogin: "",
      resourceLocation: "",
      resourcePhoneNumber: "",
      resourceStatus: "Active",
    },
    validationSchema: ResourceValidationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      createOrUpdateResourceAccount(!isEditMode, values).then((res) => {
        if (res && typeof res === "object" && res.StatusCode === 200) {
          if (isEditMode) {
            setIsDetailsUpdated(true);
            setTimeout(() => {
              setIsDetailsUpdated(false);
            }, TOAST_TIMER);
          } else {
            setIsAccountCreated(true);
          }
        }
      });
    },
  });
  const { setValues } = formik;
  useEffect(() => {
    if (isEditMode && resourceId) {
      fetchUserAccountDetails(resourceId).then((res) => {
        if (res) {
          setValues(res);
        }
      });
    }
  }, [resourceId, isEditMode, setValues, fetchUserAccountDetails]);
  const inputDisable = true;

  return (
    <StyledCreateEditResourceForm onSubmit={formik.handleSubmit}>
      {errorMessage && (
        <Alert
          type={"error"}
          message={errorMessage}
          onToastClose={hideErrorToast}
        />
      )}
      {isDetailsUpdated && (
        <Alert
          type="success"
          message={translate("labels.resourceDetailsUpdated")}
          onToastClose={() => {
            setIsDetailsUpdated(false);
          }}
        />
      )}
      <header>
        <h1 className="tma_form_title">
          {isEditMode
            ? translate("pageTitles.updateResource")
            : translate("pageTitles.newResource")}
        </h1>
      </header>
      <div className="card">
        <h1 className="tma_section-title">
          {translate("labels.generalInformation")}
        </h1>

        <section className="tma-form_field_content">
          <div className="tma_form-control">
            <Dropdown
              id={"resourceType"}
              name="resourceType"
              label={translate("labels.resourceType")}
              options={RESOURCE_TYPE_OPTIONS}
              initialValue={formik.values.resourceType}
              onChange={({ value }) => {
                formik.setFieldValue("resourceType", value);
              }}
              key={formik.values.resourceType}
            />
          </div>
        </section>

        <section className="tma-form_field_content two">
          <div className="tma_form-control">
            <Input
              labelText={translate("labels.resourceId")}
              id="resourceId"
              name="resourceId"
              disabled={true}
              value={formik.values.resourceId}
              placeholderLabelText={
                isEditMode ? "" : translate("labels.idInfoMsg")
              }
            />
          </div>

          <div className="tma_form-control">
            <Input
              labelText={translate("labels.resourceName")}
              id="resourceName"
              name="resourceName"
              value={formik.values.resourceName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.resourceName &&
                Boolean(formik.errors.resourceName)
              }
              helperText={
                formik.touched.resourceName && formik.errors.resourceName
              }
            />
          </div>
          {/* <div className="tma_form-control">
            <Input
              labelText={translate("labels.resourceCreatedOn")}
              id="resourceCreatedOn"
              name="resourceCreatedOn"
              disabled={true}
              value={formik.values.resourceCreatedOn}
            />
          </div> */}
        </section>
        {/* <section className="tma-form_field_content">
          <div className="tma_form-control">
            <Input
              labelText={translate("labels.resourceCreatedOn")}
              id="resourceCreatedOn"
              name="resourceCreatedOn"
              disabled={true}
              value={formik.values.resourceCreatedOn}
            />
          </div>
        </section> */}
        <section className="tma-form_field_content two">
          <div className="tma_form-control">
            <Input
              labelText={translate("labels.emailId")}
              id="resourceEmail"
              name="resourceEmail"
              type="email"
              showInfoToolTip={true}
              disabled={isEditMode}
              value={formik.values.resourceEmail}
              tooltipText={translate("labels.emailTooltipInfo")}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.resourceEmail &&
                Boolean(formik.errors.resourceEmail)
              }
              helperText={
                formik.touched.resourceEmail && formik.errors.resourceEmail
              }
            />
          </div>
          <div className="tma_form-control">
            <Input
              labelText={translate("labels.phoneNumber")}
              id="resourcePhoneNumber"
              name="resourcePhoneNumber"
              value={formik.values.resourcePhoneNumber}
              tooltipText={translate("labels.phonetooltipInfo")}
              showInfoToolTip={true}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 15 }}
              error={
                formik.touched.resourcePhoneNumber &&
                Boolean(formik.errors.resourcePhoneNumber)
              }
              helperText={
                formik.touched.resourcePhoneNumber &&
                formik.errors.resourcePhoneNumber
              }
            />
          </div>
        </section>
        <section className="tma-form_field_content two">
          <div className="tma_form-control">
            <Input
              labelText={translate("labels.address")}
              id="resourceLocation"
              name="resourceLocation"
              value={formik.values.resourceLocation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ maxLength: 100 }}
              error={
                formik.touched.resourceLocation &&
                Boolean(formik.errors.resourceLocation)
              }
              helperText={
                formik.touched.resourceLocation &&
                formik.errors.resourceLocation
              }
            />
          </div>
          <div className="tma_form-control">
            <Dropdown
              id={"resourceStatus"}
              name="resourceStatus"
              label={translate("labels.status")}
              options={STATUS_OPTIONS}
              initialValue={formik.values.resourceStatus}
              onChange={({ value }) => {
                formik.setFieldValue("resourceStatus", value);
              }}
              key={formik.values.resourceStatus}
            />
          </div>
        </section>
      </div>
      <div className="card">
        <h1 className="tma_section-title padding-top">
          {translate("labels.accountInformation")}
        </h1>

        <div className="tma-form_field_content">
          <div
            className={`tma_form-control ${
              inputDisable ? "control-disabled" : ""
            }`}
          >
            <Input
              labelText={translate("labels.loginEmail")}
              id="resourceLoginEmail"
              name="resourceLoginEmail"
              disabled={inputDisable}
              value={formik.values.resourceEmail}
            />
          </div>

          <div
            className={`tma_form-control ${
              inputDisable ? "control-disabled" : ""
            }`}
          >
            <Input
              labelText={translate("labels.accountCreatedDate")}
              id="resourceCreatedOn"
              name="resourceCreatedOn"
              disabled={inputDisable}
              value={formik.values.resourceCreatedOn || ""}
            />
          </div>
          <div
            className={`tma_form-control ${
              inputDisable ? "control-disabled" : ""
            }`}
          >
            <Input
              labelText={translate("labels.lastLogin")}
              id="lastLogin"
              name="lastLogin"
              disabled={inputDisable}
              value={formik.values.resourceLastLogin || ""}
            />
          </div>
        </div>
      </div>
      <div className="card no-box">
        {
          <section className="tma_form_actions">
            {!isEditMode && (
              <>
                <Button
                  text={translate("labels.cancel")}
                  type="button"
                  className={"tma_app_btn primary-outline"}
                  onClick={() => {
                    navigate(SITE_LINKS_SCHEMA.USER_MANAGEMENT);
                  }}
                />
                <Button
                  text={translate("labels.saveAndTriggerEmail")}
                  type="submit"
                  className={"tma_app_btn primary-success"}
                />
              </>
            )}
            {isEditMode && (
              <>
                <Button
                  text={translate("labels.cancel")}
                  type="button"
                  className={"primary-outline"}
                  onClick={() => {
                    navigate(SITE_LINKS_SCHEMA.USER_MANAGEMENT);
                  }}
                />
                <Button
                  text={translate("labels.saveChanges")}
                  className={"tma_app_btn primary-success"}
                  type="submit"
                />
              </>
            )}
          </section>
        }

        {isAccountCreated && (
          <InfoModal
            onClose={() => {
              navigate(SITE_LINKS_SCHEMA.USER_MANAGEMENT);
            }}
            title={translate("labels.accountCreated")}
            titleStyles={{ color: "green", fontWeight: "bold" }}
            primaryMessage={translate(
              "labels.accountConfirmationMessage"
            ).replace("$email", formik.values.resourceEmail)}
            secondaryMessage={translate("labels.accountCloseModalInfo")}
          />
        )}
        {isLoading && <Loader />}
      </div>
    </StyledCreateEditResourceForm>
  );
};

export default CreateEditResourceForm;
